import { useRef } from 'react';
import { useTranslation } from 'next-i18next';

import useAnimate from '@Hotels-at-Home/hah-fe-core/dist/hooks/useAnimate';
import HeroSection from './sections/HeroSection';
import FragranceSection from './sections/FragranceSection';
import BeddingSection from './sections/BeddingSection';
import SleepSection from './sections/SleepSection';
import MobileSection from './sections/Mobile';

const Home = () => {
  const { t: tHero } = useTranslation('', { keyPrefix: '$pages.$home.$heroSection' });
  const animateRef = useRef(null);
  const bottomRef = useRef(null);
  useAnimate(animateRef);

  return (
    <div id="home" ref={animateRef}>
      {/* The page's single h1 (SEO). It sits outside the desktop and mobile layouts, which are
          each hidden per breakpoint, so it stays in the accessibility tree at every width. */}
      <h1 className="sr-only">{tHero('title')}</h1>
      <HeroSection bottomRef={bottomRef} />
      <div className="bottom-content" ref={bottomRef}>
        <FragranceSection />
        <BeddingSection />
        <SleepSection />
      </div>
      <MobileSection />
    </div>
  );
};

export default Home;
